module.exports = __webpack_public_path__ + "static/media/Toma_Root.79258e3c.webp";